// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ckt_","location":"Header_location__2nIUM"};